import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import Button from "@hig/button";
import Modal from '../components/Widgets/Modal';
import Backdrop from '../components/Widgets/Backdrop';
import { Redirect } from "react-router-dom";
import Auth from '../scripts/auth';
import {userAuthContext} from '../context/userAuthContext';

const ErrorMessage = (props) => {
  return (
    <div className="pda-login-error">
      <p>{props.message}</p>
    </div>
  )
}

class Login extends Component {
  _isMounted = false;
  state = {
    username: '',
    password: '',
    submitted: false
  }

  handleClick(context) {
    Auth.basicLogin({username: this.state.username, password: this.state.password})
      .then((res) => {
        if(this._isMounted){
          this.setState({submitted: true})
          context.setAuthentication(true);
        }
      })
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <userAuthContext.Consumer>
        {(context) => {
          if(!context.state.isUserAuthenticated && !this.state.submitted) {
            return (
              <React.Fragment>
                <Backdrop>
                  <Modal>
                    <Modal.Header title="Login" />
                    <Modal.Body>
                      <div>
                        <MuiThemeProvider>
                          <TextField
                            hintText="Enter your Username"
                            floatingLabelText="username"
                            onChange = {(event,newValue) => this.setState({username:newValue})}
                          /><br/>
                          <TextField
                            type="password"
                            hintText="Enter your Password"
                            floatingLabelText="password"
                            onChange = {(event,newValue) => this.setState({password:newValue})}
                          />
                        </MuiThemeProvider>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        size="standard"
                        title="Submit"
                        type="primary"
                        onClick={this.handleClick.bind(this, context)}
                      />
                    {context.state.loginAttempted ? <ErrorMessage message="Login Failed. Please try again !" /> : null}
                    </Modal.Footer>
                  </Modal>
                </Backdrop>
              </React.Fragment>
            )
          } else if(context.state.isUserAuthenticated) {
            return <Redirect to={{ pathname: "/" }} />
          } else if(!context.state.isUserAuthenticated && this.state.submitted) {
            context.setLoginAttempt(true);
            return <Redirect to={{ pathname: "/" }} />
          } else {
            return <Redirect to={{ pathname: "/403" }} />
          }
        }}
      </userAuthContext.Consumer>
    )
  }
}


export default Login;
